import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-md-row justify-content-between" }
const _hoisted_2 = { class: "col-12 col-md-8 d-flex flex-column align-items-start" }
const _hoisted_3 = {
  key: 0,
  class: "my-1"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "عنوان ربات : ", -1)
const _hoisted_5 = {
  key: 1,
  class: "my-1"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "کاربر : ", -1)
const _hoisted_7 = { class: "my-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "تاریخ ساخت : ", -1)
const _hoisted_9 = { class: "my-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "وضعیت سرور : ", -1)
const _hoisted_11 = { class: "my-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "وضعیت ربات : ", -1)
const _hoisted_13 = { class: "col-12 col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.data.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("strong", null, _toDisplayString(_ctx.data.name), 1)
            ]))
          : _createCommentVNode("", true),
        ( _ctx.data.user?.first_name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("strong", null, _toDisplayString(_ctx.data.user?.first_name + " " + _ctx.data.user?.last_name), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("strong", null, _toDisplayString(_ctx.data.created_at.jalali), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("strong", null, _toDisplayString(_ctx.selected_server.status), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("strong", null, _toDisplayString(_ctx.data.status), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.selected_server?.id)
          ? (_openBlock(), _createBlock(_component_el_popconfirm, {
              key: 0,
              width: "220",
              "confirm-button-text": "بله",
              "cancel-button-text": "خیر",
              "icon-color": "#626AEF",
              onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reboot(_ctx.selected_server.id))),
              title: _ctx.translate('آیا می‌خواهید این سرور را ریبوت کنید؟')
            }, {
              reference: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.details_dialog = true)),
                  class: "text-nowrap btn btn-sm btn-outline btn-outline-dashed btn-primary btn-active-primary mx-1 col-5"
                }, " ریبوت ")
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.selected_server?.id)
          ? (_openBlock(), _createBlock(_component_el_popconfirm, {
              key: 1,
              width: "220",
              "confirm-button-text": "بله",
              "cancel-button-text": "خیر",
              "icon-color": "#626AEF",
              onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.remove(_ctx.selected_server.id))),
              title: _ctx.translate('آیا می‌خواهید این سرور را حذف کنید؟ (در صورت حذف سرور، سشن کاربر از بین می‌رود و نیاز به ورود مجدد خواهد داشت)' )
            }, {
              reference: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.details_dialog = true)),
                  class: "text-nowrap btn btn-sm btn-outline btn-outline-dashed btn-primary btn-active-primary mx-1 col-5"
                }, " حذف ")
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}